export const ACCEPT_COOKIE_NAME = 'accept-cookie';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function getCookieConsentValue() {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookie = document.cookie
    .split(';')
    .find((cookie) => cookie.trim().startsWith(`${ACCEPT_COOKIE_NAME}=`));

  if (!cookie) {
    return null;
  }

  return cookie.split('=').slice(1).join('=') === 'true';
}

export function hasCookieConsent() {
  return getCookieConsentValue() === true;
}

export function hasCookieConsentDecision() {
  return getCookieConsentValue() !== null;
}

export function setCookieConsent(value = true) {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${ACCEPT_COOKIE_NAME}=${value === true}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
}

export function hasCookieConsentQuery(query = {}) {
  return getCookieConsentQueryValue(query) !== null;
}

export function getCookieConsentQueryValue(query = {}) {
  const value = query.cookies_accepted;

  if (Array.isArray(value)) {
    const validValue = value.find((item) => getCookieConsentQueryValue({ cookies_accepted: item }) !== null);
    return validValue === undefined ? null : getCookieConsentQueryValue({ cookies_accepted: validValue });
  }

  if (value === true || value === 'true' || value === 'accepted') {
    return true;
  }

  if (value === false || value === 'false' || value === 'rejected') {
    return false;
  }

  return null;
}
